import { UseQueryResult, useQuery } from "@tanstack/react-query";
import DashboardStatusResponse from "../../models/API/responseModels/dashboardStatusResponse.mdoel";
import { useOktaAuth } from "@okta/okta-react";
import axiosInstance from "../../api";
import { useContext } from "react";
import { ApplicationState } from "../../context/ApplicationStateContext";
import buildParams from "../helpers/paramsBuilder";

function useDashboardStatus(): UseQueryResult<DashboardStatusResponse, any> {
 const { authState } = useOktaAuth();
 const { selectedPhysician, selectedOrganization, selectedPathLab } =
  useContext(ApplicationState).state;
 return useQuery({
  queryKey: [
   "dashboardStatus",
   {
    physicianId: selectedPhysician,
    pathLabId: selectedPathLab,
    organizationId: selectedOrganization,
   },
  ],
  queryFn: ({ queryKey }) => {
   const [_key, { physicianId, pathLabId, organizationId }]: any = queryKey;
   const pathlabId = pathLabId;
   return axiosInstance
    .get(
     `/v1/orders/new-flow/dashboard-status${buildParams({
      physicianId,
      pathlabId,
      organizationId,
     })}`,
     {
      headers: {
       Authorization: `Bearer ${authState?.accessToken?.accessToken}`,
      },
     }
    )
    .then((res) => res.data);
  },
  enabled: !!authState?.accessToken?.accessToken,
 });
}

export default useDashboardStatus;
